<template>
  <div class="modal" @click.self="callModalAction">
    <component :is="type" @toggleModal="callModalSecondAction"></component>
  </div>
</template>

<script>
/**
 * 
 * I SUGGEST USING SLOTS INSTEAD OF PASSING TYPE AS PROPS and generating a mesh of dependencies
 * 
 * this is way too generic, wth is 'callModalSecondAction'?! ridiculously uninformative
 * https://stackoverflow.com/a/42998087
 * ^ much nicer ^
 */


// import PreferenceSettings from "./PreferenceSettings";
import SessionComplete from "./Timer/SessionComplete";
export default {
  name: "DefaultModal",
  props: ["type"],
  components: {
    // PreferenceSettings,
    SessionComplete,
    /* Lazy load for these components looked too slow & clunky,
    would need to be pre-loaded, but the prefetch didn't work. */
    // PreferenceSettings: () =>
    //   import(/* webpackPrefetch: true */ "./PreferenceSettings.vue"),
    // SessionComplete: () =>
    //   import(/* webpackPrefetch: true */ "./Timer/SessionComplete"),
  },
  methods: {
    callModalAction() {
      if (this.type == "PreferenceSettings") {
        this.togglePreferences();
      }
    },

    callModalSecondAction() {
      this.$emit("callModalSecondAction");
    },

    togglePreferences() {
      this.$store.dispatch("cofocusPreferences/togglePreferences");
    },
  },
};
</script>

<style scoped>
.modal {
  position: absolute;
  z-index: 9999999999;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  overflow: auto;
}
</style>